module.exports = __webpack_public_path__ + "img/bonus8.ccd8d6f5.png";